import {
  WbCardContent,
  WbTruncatedTypographyWrapper,
  WbVerticalTabs,
} from '@agilelab/plugin-wb-platform';
import { FC, useCallback, useMemo } from 'react';
import { TeamRoleEnum } from '@agilelab/plugin-wb-team-roles-common';
import { useTeamRolesPanelContext } from '../../../context';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

const DISABLED_TOOLTIP =
  'Onboard this project to be able to manage other Team Roles.';

export const TeamRolesCard: FC = () => {
  const { hasPrincipalOwner, enabledTeamRoles } = useTeamRolesPanelContext();

  const checkIfDisabled = useCallback(
    (role: TeamRoleEnum) => !hasPrincipalOwner && role !== TeamRoleEnum.OWNER,
    [hasPrincipalOwner],
  );

  const tabs = useMemo(
    () =>
      enabledTeamRoles.map(role => ({
        label: (
          <WbTruncatedTypographyWrapper
            maxLines={1}
            breakAll
            value={role.displayName}
            enableTooltip={false}
          />
        ),
        value: role.name,
        icon: <InfoOutlinedIcon />,
        disabled: checkIfDisabled(role.name),
        tooltip: checkIfDisabled(role.name)
          ? DISABLED_TOOLTIP
          : role.description,
      })),
    [enabledTeamRoles, checkIfDisabled],
  );

  return (
    <WbCardContent
      style={{
        height: '100%',
      }}
    >
      <WbVerticalTabs tabs={tabs} aria-label="Team Roles Tabs" />
    </WbCardContent>
  );
};
